var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification && _vm.notification.type === 'INVOICE_UNLOCK')?_c('div',[_c('span'),_c('strong',[_vm._v(_vm._s(_vm.invoice))]),_c('br'),_vm._v("UNLOCKED\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }